// ============================================================
// Alpine: invitationTemplateCheckout — bayar template premium
// ============================================================

import Alpine from 'alpinejs';
import axios from '../../config/axios.js';
import { invitationCreatePath } from '../../helpers/invitationAuth.js';

function requireAuth(target) {
  const store = window.Alpine?.store('auth');
  if (!store?.isLoggedIn) {
    window.location.href = `/login?redirect=${encodeURIComponent(target)}`;
    return false;
  }
  return true;
}

export function registerInvitationTemplateCheckout() {
  Alpine.data('invitationTemplateCheckout', (slug) => ({
    slug,
    preview: null,
    paymentMethod: 'wallet',
    loading: true,
    submitting: false,
    error: '',

    init() {
      const target = `/invitations/templates/${this.slug}/checkout`;
      if (!requireAuth(target)) return;
      this.loadPreview();
    },

    formatRp(n) {
      return window.formatRupiah ? window.formatRupiah(n) : `Rp ${Number(n).toLocaleString('id-ID')}`;
    },

    async loadPreview() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/api/v1/invitations/templates/${this.slug}/checkout`);
        this.preview = data.data;
        this.paymentMethod = this.preview.wallet_sufficient ? 'wallet' : 'transfer_manual';
        this.error = '';
      } catch (e) {
        const msg = e.response?.data?.message || 'Gagal memuat checkout.';
        if (e.response?.status === 422 && msg.includes('sudah memiliki')) {
          window.location.href = invitationCreatePath(this.slug);
          return;
        }
        this.error = msg;
      } finally {
        this.loading = false;
      }
    },

    async submit() {
      if (this.paymentMethod === 'wallet' && !this.preview?.wallet_sufficient) {
        this.error = 'Saldo wallet tidak mencukupi.';
        return;
      }

      this.submitting = true;
      this.error = '';

      try {
        const { data } = await axios.post(`/api/v1/invitations/templates/${this.slug}/purchase`, {
          payment_method: this.paymentMethod,
        });

        const payload = data.data;

        if (payload.payment_status === 'paid') {
          window.toast?.(data.message || 'Pembayaran berhasil!', 'success');
          window.location.href = payload.redirect_url || invitationCreatePath(this.slug);
          return;
        }

        sessionStorage.setItem('uspatih_pending_order', JSON.stringify({
          order_id: payload.order_id,
          order_number: payload.order_number,
          grand_total: payload.price_paid,
          payment: payload.payment,
          payment_status: payload.payment_status,
        }));

        if (this.paymentMethod === 'xendit' && payload.payment?.invoice_url) {
          window.location.href = payload.payment.invoice_url;
          return;
        }

        window.location.href = payload.redirect_url || `/shop/payment/${payload.order_id}`;
      } catch (e) {
        this.error = e.response?.data?.message || 'Pembayaran gagal.';
      } finally {
        this.submitting = false;
      }
    },
  }));
}

registerInvitationTemplateCheckout();
